import { ItemType } from '@vista-digital/ocapi-types/v1';
export const getModifiersForOrderItemLine = (orderItemLine) => {
    if (orderItemLine.type !== ItemType.Normal)
        return [];
    return orderItemLine.modifierGroups.reduce((acc, group) => acc.concat(group.modifiers), []);
};
